import { render } from "./TOS.vue?vue&type=template&id=3788bfb1&scoped=true"
import script from "./TOS.vue?vue&type=script&lang=js"
export * from "./TOS.vue?vue&type=script&lang=js"

import "./TOS.vue?vue&type=style&index=0&id=3788bfb1&scoped=true&lang=css"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3788bfb1"]])

export default __exports__